import React from 'react';
import { Phone } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 lg:py-28 bg-brand-blue relative overflow-hidden" data-id="element-187">
      <div className="absolute inset-0 opacity-10" data-id="element-188">
        <div className="absolute -top-[50%] -right-[10%] w-[70%] h-[150%] rounded-full bg-white blur-3xl" data-id="element-189" />
        <div className="absolute top-[20%] -left-[20%] w-[50%] h-[100%] rounded-full bg-white blur-3xl" data-id="element-190" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-191">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-192">
          Need Auto Glass Repaired Today?
        </h2>
        <p className="text-xl text-red-50 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-193">
          Do not wait for a cracked windshield or broken car window to get
          worse. Request a free quote from Kosin's Glass and get help with the
          safest next step.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-194">
          <a href="#quote" className="w-full sm:w-auto bg-white text-brand-blue hover:bg-slate-50 font-bold text-lg py-4 px-8 rounded-xl transition-colors shadow-xl" data-id="element-195">
            Request a Free Auto Glass Quote
          </a>
          <a href="tel:517-545-7772" className="w-full sm:w-auto bg-transparent border-2 border-white/30 text-white hover:bg-white/10 font-bold text-lg py-4 px-8 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-196">
            <Phone className="w-5 h-5" data-id="element-197" />
            Call 517-545-7772
          </a>
        </div>

        <div className="mt-8 flex flex-col items-center gap-2" data-id="element-198">
          <div className="flex items-center gap-0.5 text-amber-300" aria-hidden="true" data-id="element-199">
            <span data-id="element-200">★</span>
            <span data-id="element-201">★</span>
            <span data-id="element-202">★</span>
            <span data-id="element-203">★</span>
            <span data-id="element-204">★</span>
          </div>
          <p className="text-sm text-red-50/90" data-id="element-205">
            Trusted by Southeast Michigan drivers for windshield replacement,
            auto glass repair and insurance coordination.
          </p>
        </div>
      </div>
    </section>;
}